<template>
<div>
    <smallbutton toplabel="Update Group" @click="start()" v-if="showButton" :buttonclass="buttonclass"/>
    <linkbutton toplabel="Update Group" @click="start()" v-if="!showButton"/>
    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="balform">
                <label class="titlelabel">Update Product Group</label>
                <br/>
                
            
                <formentry inputid="groupname"  label="Name"  v-model="productGroup.name" :isrequired="trueParam" />
                
                <div>
                    <label  class="required">{{requiredFieldLabel}}</label>
                </div>

                  <!-- image -->
                <div class="showProductImage">
                    <br>
                    <br>
                    <div class="personPhoto" v-if="productGroup.imageFilename!=null">
                        <img alt="product image" :src="getProductImage"  width="100" class="" >
                    </div>

                    <smallbutton toplabel="Add Image" @Click="addfile"  v-if="productGroup.imageFilename==null"/>
                    <smallbutton toplabel="Replace Image" @Click="addfile"  v-if="productGroup.imageFilename!=null"/>
                    <smallbutton toplabel="Edit Image" v-if="productGroup.imageFilename!=null" @click="editImage()" />

                    <imagealldoc ref="imgdoc"  fileAccept="*.*"  :allowFileSelect="trueParam" :allowCapture="falseParam" @saveimg="saveimg_document"  :showImage='falseParam' />
                    <imageeditor ref="imgedit" :img="selectedImageURL" @save="saveimg_document"/>
                </div>

                <div>
                    <label class="pleasewait" v-if="pleaseWait">Please Wait...</label>
                </div>
                <smallbutton  @click="save()" toplabel="Save" buttonclass="button buttonsave"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close" buttonclass="button buttoncancel"/>
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
                
            </form>
            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../services/datamethods.js'
import {mapFields} from 'vuex-map-fields'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import linkbutton from '../controls/linkbutton.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
 import imagealldoc from '../controls/ImageAll.vue'
 import imageeditor from '../controls/ImageEditor.vue'
export default {
    name:'renamegroup',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
        imagealldoc,
        imageeditor
    },
    props:{
        
        showButton:{
            type:Boolean,
            default:false
        },
        productGroup:{
            type:Object,

        },
         buttonclass:{
          type:String,
          default:"button buttonprimary"
        },
        
    },
    mixins:[datamethods,format],
    data(){
        return{
            
            responseMessage:'',
            pleaseWait:false,
            
            locationList:[],
            requiredFieldLabel:'* required',
            trueParam:true,
            falseParam:false,
            selectedImageURL:null,
        }
    },
    computed:{
        ...mapFields([


        ]),
        getProductImage(){
       
                if(this.productGroup.imageFilename==null){return null}
                    var imgBasePath =  window.VUE_CONFIG_API + 'personimage/'

                var fn = this.productGroup.imageFilename
                var splitfn=fn
                const lastDot = fn.lastIndexOf('.');
                if (lastDot > 0) {
                splitfn= fn.slice(0, lastDot) + '/' + fn.slice(lastDot + 1);
                }
                this.selectedImageURL=imgBasePath + splitfn
                    return imgBasePath + splitfn
        },
    },
    mounted(){
        this.GetLocations()
    },
    methods:{
        beforeAPI(){
            this.pleaseWait=true
            this.responseMessage=''
        },
        
      
        start(){
           
            

            this.$refs.mymodal.openModal()
        },
        async save(){
           let req = {
                productGroup:this.productGroup
            }
             this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'addproductgroup')
            //handle response
            if(response.Successful){
                this.$emit('saved')
                this.$refs.mymodal.closeModal()
                
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },

       async GetLocations(){
            
                this.beforeAPI();
                var response = await this.callAPI(null,'locations')

                if(response.Successful){
                    this.locationList=response.locationList
                
                }else{
                    this.responseMessage = response.Message
                }
                this.pleaseWait=false;
           
        },
        editImage(){
            this.$nextTick(()=>{
                this.$refs.imgedit.openModal()
            })
        },
       addfile(){
            this.$refs.imgdoc.openModal() 
        },
        saveimg_document(file,url,typeId){
                    this.storeDocument("doc", file, file.name,typeId)
        },
        
        async storeDocument(filename,file, name,typeId){
            var pId=this.productGroup.id
            var postParams = new FormData();

            postParams.append(filename,file,name);
            postParams.append('productGroupId',pId);

            this.pleaseWait=true
            var response = await this.callAPI(postParams,'saveproductgroupimage')
            //handle response
            if(response.Successful){
                //this.RefreshCurrent() 
                this.productGroup.imageFilename= response.fileName
                
            }else{
                this.responseMessage = response.Message
            }
              this.pleaseWait=false  
        },   
       
        
    }
}
</script>

<style>

</style>





























